import tw from "twin.macro";

export const Divider = tw.div`h-[0.0625rem] bg-shade-10`;
